import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { IconSize } from '../../../Icons/IconWrap';
import NotificationIcon from '../../../Icons/24x24/Notification';
import { BiEventType, BiLink } from '../../../biLogger';
import { limitNumber } from '../../helpers';
import TextTooltipOnHover from '../../../Popover/TextTooltipOnHover';
import { useBiLogger } from '../../../biLogger/hooks/useBiLogger';
import s from './NotificationCenterButton.scss';
var NotificationCenterButton = function (_a) {
    var feedbackCount = _a.feedbackCount;
    var t = useTranslation().t;
    var formattedCount = limitNumber(feedbackCount);
    var logBiEvent = useBiLogger();
    var timerRef = useRef(null);
    return (React.createElement(TextTooltipOnHover, { tooltipText: t('siteHeader.notifications.tooltip') },
        React.createElement(BiLink, { biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'notifications',
                indicator: feedbackCount,
            }, className: s['root'], href: Url.feedbackLink(), "aria-label": t(feedbackCount
                ? 'siteHeader.a11y.notifications.withItems'
                : 'siteHeader.a11y.notifications.withoutItems', {
                formattedCount: formattedCount,
            }) },
            React.createElement("span", { className: s['inner'], onMouseEnter: function () {
                    return (timerRef.current = setTimeout(function () {
                        return logBiEvent({
                            evid: BiEventType.DEFAULT,
                            view: 'notifications',
                            component: 'tooltip',
                            click_info: 'notifications_tooltip',
                        });
                    }, 100));
                }, onMouseLeave: function () { return clearTimeout(timerRef.current); } },
                React.createElement(NotificationIcon, { className: s['icon'], size: IconSize.MEDIUM }),
                !!feedbackCount && (React.createElement("span", { className: s['number'] }, formattedCount))))));
};
export default NotificationCenterButton;
//# sourceMappingURL=NotificationCenterButton.js.map